import { ProgramCounter } from './ProgramCounter';
export class KnownProgramCounter extends ProgramCounter {
    constructor(pc) {
        super();
        this.pc = pc;
    }
    plus(offset) {
        return new KnownProgramCounter(this.pc + offset);
    }
    equals(other) {
        return other instanceof KnownProgramCounter && this.pc === other.pc;
    }
    getPC() {
        return this.pc;
    }
}

//# sourceMappingURL=KnownProgramCounter.js.map
